import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import { ConnectionMonitor } from '../connectionMonitor'
import { NotFoundImage } from '../notFoundImage'
import { ErrorStateProps } from './errorState.types'
import { Wrapper } from './errorState.styles'

const ErrorState = ({
  title = i18n.t('paywall.error_state.title'),
  description = i18n.t('paywall.error_state.description'),
  hasViewAsBar = false,
  connectionMonitor
}: ErrorStateProps) => {
  const handleReloadPage = () => {
    window.location.reload()
  }

  return (
    <Wrapper
      className="_d-flex _justify-content-center _align-items-center _flex-column _text-center _py-4"
      hasViewAsBar={hasViewAsBar}
    >
      <NotFoundImage className="_mb-4" />
      <h2 className="_text-3 _mb-2">{title}</h2>
      <p className="_text-gray-600 _text-2 _mb-4">{description}</p>

      <Button variation="primary" onClick={handleReloadPage}>
        {i18n.t('paywall.error_state.reload')}
      </Button>

      {connectionMonitor && <ConnectionMonitor onConnect={handleReloadPage} />}
    </Wrapper>
  )
}

export default ErrorState
